import React, {useEffect, useState} from "react";
import {useSite} from "../../context/SiteContext";
import {APP_ANDROID, APP_FEATS, APP_IOS, APP_SHOTS, SCREEN} from "../../data/siteData";
import {asset, prefersReducedMotion, stagger} from "../../utils";
import Icon, {StoreGlyph} from "../common/Icon";
import {PhoneScreen} from "./HowItWorks";

// One phone cycling through the app screens, next to the app download links.
const AppShowcase = () => {
    const {appOpen} = useSite();
    const [shot, setShot] = useState(0);

    useEffect(() => {
        // Auto-advance, except for readers who asked for less motion (the dots still work).
        if (prefersReducedMotion() || appOpen) return;
        const timer = setInterval(() => setShot(s => (s + 1) % APP_SHOTS.length), 3400);
        return () => clearInterval(timer);
    }, [appOpen]);

    return (
        <section className="pb-app">
            <div className="pb-app-grid">
                <div className="pb-app-phone-col">
                    <div className="pb-app-phone">
                        <div className="pb-app-screen" style={{aspectRatio: SCREEN.ratio}}>
                            {APP_SHOTS.map((a, i) => (
                                // The outgoing screen slides left and the next arrives from the right.
                                <div key={a.src} className="pb-app-shot" style={{
                                    opacity: i === shot ? 1 : 0,
                                    transform: `translateX(${i === shot ? '0%' : (i < shot ? '-22%' : '22%')}) scale(${i === shot ? 1 : 0.96})`
                                }}>
                                    <PhoneScreen src={a.src} alt={a.alt}/>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div style={{display: 'flex', gap: 8, alignItems: 'center'}}>
                        {APP_SHOTS.map((a, i) => (
                            <button key={a.src} onClick={() => setShot(i)} aria-label={a.alt} className="pb-app-dot"
                                    style={{
                                        width: i === shot ? '22px' : '6px',
                                        background: i === shot ? '#FFCE00' : 'rgba(255,255,255,0.34)'
                                    }}/>
                        ))}
                    </div>
                    <p className="pb-app-shot-label">{APP_SHOTS[shot].label}</p>
                </div>
                <div>
                    <img src={asset('assets/logo-white.png')} alt="Paddlers Box"
                         style={{height: 34, display: 'block', marginBottom: 18}}/>
                    <p className="pb-pill" style={{background: 'rgba(255,255,255,0.12)', color: '#7fd4ff'}}>
                        <Icon name="phone" size={16}/>The app
                    </p>
                    <h2 className="pb-app-title">Your adventure, in your pocket</h2>
                    <p className="pb-app-lead">Live availability, the scanner that opens the box, and the nearest box
                        wherever you happen to be standing.</p>
                    <div style={{display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 30}}>
                        {APP_FEATS.map((text, i) => (
                            <div key={text} className="pb-reveal pb-app-feat" style={{animationDelay: stagger(i, 70)}}>
                                <span><Icon name="check" size={13}/></span>
                                <span>{text}</span>
                            </div>
                        ))}
                    </div>
                    <p className="pb-app-download">Download now — iOS &amp; Android</p>
                    <div style={{display: 'flex', gap: 12, flexWrap: 'wrap'}}>
                        <a href={APP_IOS} target="_blank" rel="noopener noreferrer" className="pb-app-store pb-app-store-ios">
                            <StoreGlyph kind="ios"/>Download on iOS
                        </a>
                        <a href={APP_ANDROID} target="_blank" rel="noopener noreferrer"
                           className="pb-app-store pb-app-store-android hover-brighten">
                            <StoreGlyph kind="play"/>Get it on Google Play
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AppShowcase;
